import { render } from "./BannerOpenHouse.vue?vue&type=template&id=4b319631"
import script from "./BannerOpenHouse.vue?vue&type=script&lang=js"
export * from "./BannerOpenHouse.vue?vue&type=script&lang=js"

import exportComponent from "/var/app/current/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__